<template>
<div id="pageTable">
    <v-container grid-list-xl fluid>
        <v-card>
            <v-layout class="d-flex flex-lg-row flex-md-column flex-sm-column" wrap pa-3>
                <v-flex lg4 md4 sm12>
                    <h-currency-input v-model="vLength" :decimal="0" label="Chiều dài (cm)" class="input-group--focused"></h-currency-input>
                </v-flex>
                <v-flex lg4 md4 sm12>
                    <h-currency-input v-model="vWidth" :decimal="0" label="Chiều rộng (cm)" class="input-group--focused"></h-currency-input>
                </v-flex>
                <v-flex lg4 md4 sm12>
                    <h-currency-input v-model="vHeight" :decimal="0" label="Chiều cao (cm)" class="input-group--focused"></h-currency-input>
                </v-flex>
                <v-flex lg4 md4 sm12>
                    <h-currency-input v-model="vWeight" :decimal="1" label="Cân nặng (kg)" class="input-group--focused"></h-currency-input>
                </v-flex>
                <v-flex lg4 md4 sm12>
                    <v-select label="Hình thức vận chuyển" v-model="vproductType" :items="shipping_methods" item-text="name" item-value="value"></v-select>
                </v-flex>
                <v-flex lg4 md4 sm12 pa-6>
                    <v-btn color="oee-theme darken-1 white--text" @click="calcData()">Tính</v-btn>
                </v-flex>
                <v-flex lg12 md12 sm12 pt-6>
                    <v-divider></v-divider>
                </v-flex>
                <v-flex lg6 md6 sm12>
                    Cân nặng
                </v-flex>
                <v-flex lg6 md6 sm12>
                    {{vWeight | currency('',1)}} kg
                </v-flex>
                <v-flex lg6 md6 sm12>
                    Phí tính theo cân
                </v-flex>
                <v-flex lg6 md6 sm12>
                    {{item.weightFeeAmount | currency('₫')}}
                </v-flex>
                <v-flex lg6 md6 sm12>
                    Thể tích
                </v-flex>
                <v-flex lg6 md6 sm12>
                    {{item.volume | currency('', 3)}} m3
                </v-flex>
                <v-flex lg6 md6 sm12>
                    Phí tính theo thể tích
                </v-flex>
                <v-flex lg6 md6 sm12>
                    {{item.volumeFeeAmount | currency('₫')}}
                </v-flex>
            </v-layout>
        </v-card>
    </v-container>
</div>
</template>

<script>
import configs from "../../configs";
import { sendErrorNotice } from "@/commons/utils";
import { mapState } from "vuex";
import _ from "lodash";
export default {
    data() {
        return {
            shipping_methods: configs.SHIPPING_METHOD,
            vproductType: -1,
            vLength: 0,
            vWidth: 0,
            vHeight: 0,
            vWeight: 0
        }
    },
    computed: {
        ...mapState({
            item: state => state.commons.calcData,
        })
    },
    methods: {
        calcData() {
            if(this.vproductType == -1) {
                sendErrorNotice('Vui lòng chọn loại hàng để tính cước')
            }
            this.$store.dispatch("commons/getCalcData", {weight: this.vWeight, height: this.vHeight, length: this.vLength, width: this.vWidth, type: this.vproductType});
        }
    },
    mounted() {
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
    }
};
</script>

<style>
</style>
